import PreModerCommentsPage from './premoderation-comments-page'

export default PreModerCommentsPage
